import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { v4 as uuidv4 } from 'uuid';

import { IUsuario } from '../../../hooks/chat';

import socket from '../../../services/socket';
import { useClinica } from '../../../hooks/clinica';
import { ISendMessage } from '../../../components/Chat';
import Button from '../../../components/Button';
import Queue from '../../../utils/queue';
import { IFilaChamado } from '../../AgendaAtendimento';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import { useToast } from '../../../hooks/toast';
import {
  ContainerGrid,
  Header,
  ContainerImagem,
  Footer,
  Rooler,
  RoolerText,
  Painel,
  BoxPainel,
  Lateral,
  BoxLateral,
} from './styles';

import Input from '../../../components/Input';
import { Container, Content } from '../../SignIn/styles';
import Loading from '../../../components/Loading';
import { IAgendaSala } from '../../AgendaSalas';

const audio = new Audio();

interface FormDados {
  token: string;
}

const ListaPacientesPainel: React.FC = () => {
  const { addToast } = useToast();
  const [logado, setLogado] = useState(false);
  const [loading, setLoading] = useState(false);

  const [queue, setQueue] = useState(new Queue<IFilaChamado>());
  const [top, setTop] = useState<IFilaChamado | undefined>(undefined);
  // const [size, setSize] = useState(0);

  const [verifica, setVerifica] = useState(0);

  const [fila, setFila] = useState<IFilaChamado[]>([]);
  const [ultimoChamado, setUltimoChamado] = useState<
    IFilaChamado | undefined
  >();

  const formRefToken = useRef<FormHandles>(null);
  // const { addToast } = useToast();
  // const { user, clinica } = useAuth();
  // const { imagensClinica } = useClinica();
  // const { params } = useRouteMatch<IUrlParams>();
  // const { token } = params;

  const { optionsClinica } = useClinica();

  useEffect(() => {
    const pegahora = (): void => {
      setVerifica(Math.floor(Date.now()));
    };
    setInterval(() => pegahora(), 10000);
    return () => pegahora();
  }, []);

  const handlePush = (dados: IFilaChamado): void => {
    setQueue(queue);
    queue.enqueue(dados);
    setTop(queue.peek());
    // setSize(queue.size());
  };

  const handlePop = (): void => {
    queue.dequeue();
    setTop(queue.peek());
    // setSize(queue.size());
  };

  useEffect(() => {
    let sessionId = localStorage.getItem('@AgendaFacil:sessionId');
    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem('@AgendaFacil:sessionId', JSON.stringify(sessionId));
    }

    const usuario: IUsuario = {
      clinica: optionsClinica[0]?.label || 'Painel Clinica Definida',
      socketId: socket.id,
      codClinica: '0',
      pagina: 'Painel',
      sessionId,
      usuCodigo: '0',
      usuNome: 'Painel',
      usuTipo: 7,
    };
    socket.emit('registro', usuario);

    socket.on('connect', () => {
      socket.emit('registro', usuario);
    });
    socket.on('connect_error', () => console.log('erro de conexão'));
    socket.on('disconnect', (reason: string) =>
      console.log(`desconectado ${reason}`),
    );

    return () => {
      socket.removeEventListener('connect');
      socket.removeEventListener('connect_error');
      socket.removeEventListener('disconnect');
      socket.removeEventListener('desconectar');
    };
  }, [optionsClinica]);

  useEffect(() => {
    const next = (): void => {
      handlePop();
    };
    audio.addEventListener('ended', next, false);

    return () => {
      audio.removeEventListener('ended', next);
    };
  }, []);

  useEffect(() => {
    async function VerificaServidor(): Promise<void> {
      try {
        const response = await api.get('/clinicas/datahora');
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Sem Comunicação com o servidor',
          type: 'error',
          description: mensagemErro,
          timeAlive: 10000,
        });
      }
    }

    if (audio.paused && top && logado) {
      audio.src =
        top.Arquivo && top.Arquivo !== ''
          ? top.Arquivo
          : 'https://app-agenda-modelo.s3.amazonaws.com/audio/_audio_padrao.mp3';
      audio.play();

      setUltimoChamado(top);

      const nome = document.getElementById('nomePaciente');
      if (nome) {
        nome.style.animationName = 'none';

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (nome) nome.style.animationName = '';
          }, 0);
        });
      }

      setFila(state => {
        const estado = state.find(
          st =>
            st.PacCodigo === top.PacCodigo && st.AgeCodigo === top.AgeCodigo,
        );

        if (estado) return state;

        if (state.length > 9) state.pop();
        return state ? [top].concat(state) : [top];
      });
    } else {
      VerificaServidor();
    }
  }, [audio, verifica]);

  useEffect(() => {
    const handleNewMessage = (data: ISendMessage): void => {
      const chamado: IFilaChamado = {
        AgeCodigo: data.idFrom,
        Arquivo: data.audioUrl,
        PacCodigo: data.idTo,
        Texto: data.mensagem,
        Sala: data.from,
        PacNome: data.to,
      };

      handlePush(chamado); // addAudio(data.audioUrl);
    };

    socket.on('chamar_paciente_painel', handleNewMessage);
    return () => {
      socket.removeEventListener('chamar_paciente_painel', handleNewMessage);
    };
  }, []);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IFilaChamado[]>('/filaChamados');

        const ultimos10 = response.data.splice(0, 10);

        setFila(ultimos10);
        setUltimoChamado(ultimos10[0]);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar fila de pessoas',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, []);

  const handleSubmit = useCallback(
    async (dados: FormDados) => {
      try {
        setLoading(true);

        const response = await api.patch<IAgendaSala>(`/salas/validatoken`, {
          token: dados.token,
        });

        setLogado(true);
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao validar token',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  const handleChamarPaciente = useCallback((dados: IFilaChamado) => {
    const mensagem: ISendMessage = {
      clinica: '1',
      from: dados.Sala,
      idFrom: dados.AgeCodigo,
      to: dados.PacNome,
      idTo: dados.PacCodigo,
      mensagem: dados.Texto,
      lida: false,
      created_at: new Date(),
      painel: true,
      audioUrl: dados.Arquivo,
    };
    socket.emit('chamar_paciente', mensagem);
  }, []);

  return (
    <>
      {loading && <Loading />}

      {!logado && (
        <>
          <Container className="justify-content-center">
            <Content>
              <Form ref={formRefToken} onSubmit={handleSubmit}>
                <h1>Token</h1>
                <Input
                  name="token"
                  required
                  placeholder="Insira o token de acesso"
                  textUppercase={false}
                  type="password"
                />
                <br />

                <Button loading={loading} type="submit" className="mt-2">
                  Entrar
                </Button>
              </Form>
            </Content>
          </Container>
        </>
      )}

      {logado && (
        <ContainerGrid>
          <Header>
            <ContainerImagem>
              <img
                src="https://app-agendafacil.s3.us-east-1.amazonaws.com/sistema/logo.png"
                alt="DR Saude"
              />{' '}
              {/* COLOCAR CIDADE DA UNIDADE? Dr. Saúde */}
            </ContainerImagem>
          </Header>
          <Footer>
            <Rooler>
              <RoolerText>
                Cuide da sua saúde, ela é seu bem mais precioso!
                <br />
                Prevenção é o melhor remédio!
                <br />
                Sorria, faz bem para a saúde!
                <br />
                Beba água e mantenha-se hidratado.
                <br />
              </RoolerText>
            </Rooler>
          </Footer>
          <Painel>
            <BoxPainel>
              {ultimoChamado && (
                <>
                  <p id="nomePaciente">{ultimoChamado.PacNome}</p>
                  <p>{ultimoChamado.Sala}</p>
                </>
              )}
            </BoxPainel>
          </Painel>
          <Lateral>
            <BoxLateral>
              <p>Últimas Senhas Chamadas</p>
              <br />
              <table>
                <thead>
                  <tr>
                    <th>Paciente</th>
                    <th>Sala</th>
                  </tr>
                </thead>
                <tbody>
                  {fila.map(f => (
                    <tr key={`td-${f.PacCodigo}-${f.AgeCodigo}-${f.Sala}`}>
                      <td>{f.PacNome}</td>
                      <td>{f.Sala}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </BoxLateral>
          </Lateral>
        </ContainerGrid>
      )}
    </>
  );
};

export default ListaPacientesPainel;
